// extracted by mini-css-extract-plugin
module.exports = {"container":"EEW6ex2O","description":"togFSSMs","img":"YjqZP71X","title":"Oc8S02to","message":"OY6Eswpq","styledButton":"nWESnsGO"};